import React, { memo } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Image from '@v4/components/common/Image'
import EditableHTML from '@v4/components/common/EditableHTML'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import { Box } from '@material-ui/core'
import { useContent } from './Content.hooks'

const Content = props => {
	const [
		{
			classes,
			image,
			text,
			textConfig,
			isPaper,
			className,
			withImage,
			extraShortcuts,
			Element,
			textEditable,
			textKey,
		},
		{ onImageClick, onTextClick, onClick, handleTextChange },
	] = useContent(props)

	return (
		<Element className={clsx(classes.root, className, 'testimonial-content')} elevation={0} onClick={onClick}>
			{withImage && (
				<Image className={clsx(classes.image, 'testimonial-image')} metaData={image} onClick={onImageClick} />
			)}
			<EditableContainer
				visible={!!text}
				fieldConfig={textConfig}
				onAdd={handleTextChange}
				editable={textEditable}
				usePaperColors={isPaper}
				wrapper={({ children }) => (text ? children : <Box width="100%">{children}</Box>)}
			>
				<EditableHTML
					key={textKey}
					usePaperColors={isPaper}
					className={clsx(classes.text, 'testimonial-text-block')}
					align="left"
					html={text}
					editable={textEditable}
					onClick={onTextClick}
					extraShortcuts={extraShortcuts}
					onChange={handleTextChange}
				/>
			</EditableContainer>
		</Element>
	)
}

Content.propTypes = {
	image: PropTypes.instanceOf(PageMetaData),
	text: PropTypes.string,
	textConfig: PropTypes.object,
	className: PropTypes.string,
	classes: PropTypes.shape({
		root: PropTypes.string,
		text: PropTypes.string,
		image: PropTypes.string,
	}),
	isPaper: PropTypes.bool,
	rounding: PropTypes.number.isRequired,
	textEditable: PropTypes.bool,
	onTextChange: PropTypes.func,
	textKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	mobileAlignment: PropTypes.instanceOf(PageMetaData),
	onClick: PropTypes.func,
}

Content.defaultProps = {
	isPaper: false,
}

export default memo(Content)
